var _path, _path2, _path3, _g, _path4, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Blueprint50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1976D2",
    d: "M7 7H36V40H7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A5F5",
    d: "M11 8H12V39H11zM15 8H16V39H15zM19 8H20V39H19zM23 8H24V39H23zM27 8H28V39H27zM31 8H32V39H31z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A5F5",
    d: "M8 11H35V12H8zM8 15H35V16H8zM8 19H35V20H8zM8 23H35V24H8zM8 27H35V28H8zM8 31H35V32H8zM8 35H35V36H8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1565C0",
    d: "M36 40L36 15.172 35.586 15.586 14.172 37 17.172 40z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1565C0",
    d: "M36 40L36 30 26 40 28.828 40z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA000",
    d: "M15.858 25.757H44.141999999999996V34.242000000000004H15.858z",
    transform: "rotate(-45.001 30 30)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#9E6400",
    d: "M34.125 19.406H36.688V21.406H34.125z",
    transform: "rotate(45.001 35.407 20.406)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9E6400",
    d: "M31.656 22.314H33.656V26.999H31.656z",
    transform: "rotate(134.999 32.656 24.656)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9E6400",
    d: "M24.656 29.314H26.656V33.999H24.656z",
    transform: "rotate(134.999 25.656 31.656)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9E6400",
    d: "M20.406 33.125H22.406V35.688H20.406z",
    transform: "rotate(134.999 21.406 34.406)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9E6400",
    d: "M27.406 26.125H29.406V28.688H27.406z",
    transform: "rotate(134.999 28.406 27.406)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1976D2",
    d: "M15.586 35.586L15 36.172 15 37.828 15.586 38.414 16 38.828 16 36 18 36 19 35 16.172 35zM27 39L28 39 28 38zM35 32L35 31 34 32zM32 39L32 36 35 36 35 35 32 35 32 34 30 36 31 36 31 39zM19 32.172L19 35 20 34 20 32 22 32 23 31 20.172 31zM27 24.172L27 27 28 26 28 24 30 24 31 23 28.172 23zM23 28.172L23 31 24 30 24 28 26 28 27 27 24.172 27zM31 20.172L31 23 32 22 32 20 34 20 35 19 32.172 19z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Blueprint50);
export default __webpack_public_path__ + "static/media/icons8-blueprint-50.10ddd6b1a734f240de0e83124177034e.svg";
export { ForwardRef as ReactComponent };